import "core-js/modules/es.parse-int.js";
import { getCurrentPath } from "@faire/web/common/Path";
import { extractVersionNumber } from "./extractVersion";
var getMobileAppVersion = function getMobileAppVersion() {
  return getCurrentPath().searchParams.get("app_version");
};
/**
 * Returns true if the current mobile app version is above the baseline version.
 * @param baselineVersion The baseline version to compare against.
 * @returns True if the current mobile app version is above the baseline version.
 * @example
 * CurrentMobileAppVersion: 23.18.0
 * isCurrentMobileAppVersionAbove("23.19.0"); // true
 * isCurrentMobileAppVersionAbove("20.3.1"); // false
 */
export var isCurrentMobileAppVersionAbove = function isCurrentMobileAppVersionAbove(baselineVersion) {
  var _currentAppVersionPar;
  var mobileAppVersion = getMobileAppVersion();
  if (!mobileAppVersion) {
    return false;
  }
  var currentAppVersionParts = mobileAppVersion.split(".");
  var baselineVersionParts = baselineVersion.split(".");
  if (currentAppVersionParts.length !== 3 || baselineVersionParts.length !== 3) {
    return false;
  }
  var currentYear = currentAppVersionParts[0];
  var currentWeek = currentAppVersionParts[1];
  var currentRevision = extractVersionNumber((_currentAppVersionPar = currentAppVersionParts[2]) !== null && _currentAppVersionPar !== void 0 ? _currentAppVersionPar : "");
  var baselineYear = baselineVersionParts[0];
  var baselineWeek = baselineVersionParts[1];
  var baselineRevision = baselineVersionParts[2];
  if (currentYear && baselineYear) {
    if (parseInt(currentYear) > parseInt(baselineYear)) {
      return true;
    } else if (parseInt(currentYear) < parseInt(baselineYear)) {
      return false;
    } else {
      if (currentWeek && baselineWeek) {
        if (parseInt(currentWeek) > parseInt(baselineWeek)) {
          return true;
        } else if (parseInt(currentWeek) < parseInt(baselineWeek)) {
          return false;
        } else {
          if (currentRevision && baselineRevision) {
            return parseInt(currentRevision) >= parseInt(baselineRevision);
          }
        }
      }
    }
  }
  return false;
};